require('./expensesByCategoryHistogram.scss');

//@vendors
import React from 'react';
import PropTypes from 'prop-types';
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
import OKTooltip from 'components/commons/OKTooltip/OKTooltip';
import ExpensesByCategoryHistogramTooltip from './expensesByCategoryHistogramTooltip/expensesByCategoryHistogramTooltip';
import { OKBoxSectionContent } from 'commonsComponents/OKBoxSectionContent';
import { OKChart } from 'commonsComponents/OKChart';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { EmptyState } from 'commonsComponents/emptyState';
import CheckFilter from 'components/commons/filters/filters/checkFilter';
import SelectorFilter from 'components/commons/filters/filters/selectorFilter';
import FiltersContainer from 'components/commons/filters/filtersContainer';
import ExpensesByCategoryFilter from '../expensesByCategoryFilter/expensesByCategoryFilter';
import MustRender from '../commons/components/MustRender';

// @utilities
import { getCategoryIcon } from 'utilities/expensesByCategories/categoriesUtilities';
import { getCurrencySymbol } from 'utilities/currencyHelper';

// @constants
import { CHART_PROPS } from 'constants/expensesByCategories/histogramChart';
import { BAR_CHART_CREDIT, BAR_CHART_ACCOUNT_DEBIT, BAR_CHART_CREDIT_OTHER_BANKS, BAR_CHART_ACCOUNT_DEBIT_OTHER_BANKS } from 'constants/charts' ;
import { CATEGORY, ALL_CATEGORIES, BANK, ALL_BANKS } from 'constants/expensesByCategories/filters';
import { PFM_FILTERS } from 'constants/index';

class ExpensesByCategoryHistogram extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            periodSelected: 1,
            isCreditFilterSelected: true,
            isDebitFilterSelected: true,
            compareYearsFilterSelected: false,
            formatedChartData: []
        }
    }

    buildTitleBoxSection = () => {
        const { onFilter, onClearFilter, onOpenModal, hasCreditCardCountry } = this.props
        return (
            <div className="row">
                <div className="col-xs-8">
                    <div className="expenses-by-category-histogram__title-container">
                        <FormattedText value="historic-title" />
                        <OKTooltip
                            content="historic-titleTutorial"
                            offset={[10, 0]}
                            placement="right"
                        />
                    </div>
                </div>
                <div className="col-xs-4">
                    <div className="expenses-by-category-histogram__filter-container">
                        <ExpensesByCategoryFilter hasCreditCardCountry={hasCreditCardCountry} onFilter={onFilter} onClearFilter={onClearFilter} onOpenModal={onOpenModal}/>
                    </div>
                </div>
            </div>
        )
    }

    buildChartLoading = () => {
        const { fetching, fetchingCompare } = this.props;

        if (fetching || fetchingCompare) {
            return (
                <div className="expenses-by-category-histogram__chart-container__status__container">
                    <LoadingSection />
                </div>
            )
        }

    }

    buildChartError = (chartData) => {
        const { error, errorCompare, fetching, fetchingCompare } = this.props;

        if (!fetching && !fetchingCompare && ( error || errorCompare || chartData.size === 0 )) {
            return (
                <div className="expenses-by-category-histogram__chart-container__status__container">
                    <EmptyState />
                </div>
            )
        }
    }

    buildChartSection = (chartData = {}, chartDataCompare = {}) => {
        const { error, errorCompare, currency, isPfmAggregatorView, hasCreditCardCountry, fetching, fetchingCompare  } = this.props;
        let chartDataList = this.convertChartDataToArray(chartData);
        const chartDataListCompare = this.convertChartDataToArray(chartDataCompare);
        const moneyObj = { currency: currency};
        const currencySymbol = getCurrencySymbol(moneyObj);

        chartDataList.length > 12 ? chartDataList.shift() : chartDataList;
        chartDataListCompare.length > 12 ? chartDataListCompare.shift() : chartDataListCompare;

        return (
            <div className="expenses-by-category-histogram__chart-container__status">
                {this.buildChartLoading()}
                {this.buildChartError(chartData)}
                {!fetching && !fetchingCompare && !error && !errorCompare && chartData.size > 0 && <OKChart
                    data={chartDataList}
                    dataCompare={chartDataListCompare.slice(0, chartDataList.length)}
                    typeChartCompare={'LINE'}
                    keyChartCompare="debitAmountCompare"
                    customHeight={250}
                    customTooltip={false}
                    customTooltipContent={<ExpensesByCategoryHistogramTooltip hasCreditCardCountry={hasCreditCardCountry} currency={currency} />}
                    unit={` ${currencySymbol}`}
                    {...CHART_PROPS}
                    {...this.getChartColors(isPfmAggregatorView)}
                />}
            </div>
        )
    }

    getChartColors = isPfmAggregatorView => isPfmAggregatorView ?
    {colorChart:[BAR_CHART_ACCOUNT_DEBIT_OTHER_BANKS, BAR_CHART_CREDIT_OTHER_BANKS]} :
        {colorChart:[BAR_CHART_ACCOUNT_DEBIT, BAR_CHART_CREDIT]}

    convertChartDataToArray = chartData => chartData ? chartData.toJS() : []

    getOptionsSelector = () => {
        const { categoriesList } = this.props;

        return categoriesList ? (categoriesList.map(category => ({
            value: category.get('code'),
            label: formatText(`categorized-${category.get('key')}`),
            icon: getCategoryIcon(category.get('code'))
        })).unshift(
            {
                value: ALL_CATEGORIES,
                label: formatText('historic-categoryDefaultValue')
            }
        )) : []
    }

    getBankSelectOptionList = () => {
        const { bankList } = this.props;

        const bankSelectOptionList = bankList ? bankList.map(bank => ({
            value: bank.code,
            label: bank.name,
        })) : [];

        bankSelectOptionList.unshift({
            value: ALL_BANKS,
            label: formatText('historic-bankDefaultValue')
        })

        return bankSelectOptionList;
    }

    buildContent = () => {
        const { chartData, chartDataCompare, error, errorCompare, isPfmAggregatorView, fetching, fetchingCompare } = this.props;
        const hasDataToShow = !fetching && !fetchingCompare && !error && !errorCompare && chartData.size !== 0 ? true : false;
        const bankOptionList = this.getBankSelectOptionList();

        return (
            <div className="expenses-by-category-histogram">
                <div className="row">
                    <div className="col-xs-12 col-md-5 expenses-by-category-histogram__selector-category">
                        <FiltersContainer filtersId={PFM_FILTERS}>
                            <SelectorFilter
                                filterId={CATEGORY}
                                options={this.getOptionsSelector().toJS()}
                                initialSelected={ALL_CATEGORIES}
                                placeholder={formatText('historic-categoryDefaultValue')}
                                isTaggable={false}
                            />
                        </FiltersContainer>
                    </div>
                    <MustRender isTrueThat={isPfmAggregatorView}>
                        <div className="col-xs-12 col-md-5 col-md-offset-2">
                            <FiltersContainer filtersId={PFM_FILTERS}>
                                <SelectorFilter
                                    filterId={BANK}
                                    options={bankOptionList}
                                    initialSelected={ALL_BANKS}
                                    placeholder={formatText('historic-bankDefaultValue')}
                                    isTaggable={false}
                                />
                            </FiltersContainer>
                        </div>
                    </MustRender>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="expenses-by-category-histogram__chart-container">
                            {this.buildChartSection(chartData, chartDataCompare)}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <MustRender isTrueThat={hasDataToShow}>
                        <div className="col-xs-12">
                            <div className="expenses-by-category-histogram__checks-container">
                                <FiltersContainer filtersId={PFM_FILTERS}>
                                    <CheckFilter
                                        filterId={'lastYearComparison'}
                                        label={formatText('historic-lastYearExpenses')}
                                        initialValue={false}
                                        isTaggable={false}
                                    />
                                </FiltersContainer>
                            </div>
                        </div>
                    </MustRender>
                </div>
            </div>
        )
    }

    render() {
        return (
            <section className="col-lg-8 col-md-12 col-sm-12">
                <div className="expenses-by-category__histogram-container">
                    <OKBoxSectionContent
                        title={this.buildTitleBoxSection()}
                        content={this.buildContent()}
                    />
                </div>
            </section>
        );
    }
}

ExpensesByCategoryHistogram.propTypes = {
    categoriesList: PropTypes.object,
    chartDataCompare: PropTypes.object,
    chartData: PropTypes.object,
    onFilter: PropTypes.func,
    onClearFilter: PropTypes.func,
    onOpenModal: PropTypes.func,
    error: PropTypes.bool,
    errorCompare: PropTypes.bool,
    fetching: PropTypes.bool,
    fetchingCompare: PropTypes.bool,
    currency: PropTypes.string,
    isPfmAggregatorView: PropTypes.bool,
    bankList: PropTypes.array,
    hasCreditCardCountry: PropTypes.bool
};

module.exports = ExpensesByCategoryHistogram;
